import { CONFIG } from '../config.js';
import { HUD } from '../ui/HUD.js';

/**
 * Manages game scoring and win conditions.
 */
export class ScoringSystem {
    /** @type {number} */
    #score = 0;

    /** @type {number} */
    #doorstepsPooped = 0;

    /** @type {number} */
    #totalDoorsteps = 0;

    /** @type {HUD} */
    #hud;

    /**
     * @param {HUD} hud - The HUD to update
     * @param {number} totalDoorsteps - Total number of doorsteps in the game
     */
    constructor(hud, totalDoorsteps) {
        this.#hud = hud;
        this.#totalDoorsteps = totalDoorsteps;
        this.#updateHUD();
    }

    /**
     * Get current score
     * @returns {number}
     */
    get score() {
        return this.#score;
    }

    /**
     * Get doorsteps pooped count
     * @returns {number}
     */
    get doorstepsPooped() {
        return this.#doorstepsPooped;
    }

    /**
     * Award points for scratching a tree
     * @returns {number} Points awarded
     */
    awardTreeScratch() {
        this.#score += CONFIG.scoring.treeScratch;
        this.#updateHUD();
        return CONFIG.scoring.treeScratch;
    }

    /**
     * Award points for roasting a cow
     * @returns {number} Points awarded
     */
    awardCowRoast() {
        this.#score += CONFIG.scoring.cowRoast;
        this.#updateHUD();
        return CONFIG.scoring.cowRoast;
    }

    /**
     * Award points for igniting a tree
     * @returns {number} Points awarded
     */
    awardTreeBurn() {
        this.#score += CONFIG.scoring.treeBurn;
        this.#updateHUD();
        return CONFIG.scoring.treeBurn;
    }

    /**
     * Award points for igniting a house
     * @returns {number} Points awarded
     */
    awardHouseBurn() {
        this.#score += CONFIG.scoring.houseBurn;
        this.#updateHUD();
        return CONFIG.scoring.houseBurn;
    }

    /**
     * Award points for pooping on a doorstep
     * @returns {number} Points awarded
     */
    awardDoorstepPoop() {
        this.#score += CONFIG.scoring.doorstepPoop;
        this.#doorstepsPooped++;
        this.#updateHUD();
        this.#checkWinCondition();
        return CONFIG.scoring.doorstepPoop;
    }

    /**
     * Update HUD displays
     */
    #updateHUD() {
        this.#hud.updateScore(this.#score);
        this.#hud.updateDoorstepsRemaining(this.#totalDoorsteps - this.#doorstepsPooped);
    }

    /**
     * Check if win condition is met
     */
    #checkWinCondition() {
        if (this.#doorstepsPooped >= this.#totalDoorsteps) {
            this.#hud.showWinMessage(this.#score);
        }
    }
}
